import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { tagUpsert } from "../../store/actions/tenantAction";

function AddReplies({
    setIsShow,
    onAdd,
    isEdit = false,
    selectedTag = {},
}) {
    let dispatch = useDispatch();
    const { t } = useTranslation();
    const [tag, setTag] = useState(selectedTag ?? {});
    const globalReducer = useSelector((state) => state.globalReducer);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isEdit) {
            tag.tenantWabaId = globalReducer.waba?.id;
        }
        dispatch(
            tagUpsert(tag, (a) => {
                setIsShow(false);
                onAdd(a);
            })
        );
    };

    const OnInput = (e) => e.target.value = e.target.value.slice(0, e.target.dataset.maxlength);
    return (
        <form className="px-6 pb-6 pt-3 bg-white max-h-[550px] overflow-auto" onSubmit={handleSubmit}>
            <div className="grid gap-3 w-full">
                <div>
                    <div className="text-midBlack text-[13px] font-normal mb-1">
                        <label>
                            {t("Tag Name")}
                            <span className="text-red-500 text-[14px]">*</span>
                        </label>
                    </div>
                    <input
                        type="text"
                        placeholder={t("Enter tag name")}
                        value={tag?.tag} data-maxlength={80} onInput={OnInput}
                        onChange={(e) => setTag({ ...tag, tag: e.target.value })}
                        className="border border-gray-300 rounded-md py-2 text-[14px] w-[100%]"
                        required
                    />
                </div>
            </div>
            <div className="col-span-12">
                <div className="flex justify-end gap-2 mt-[30px]">
                    <button
                        type="button"
                        className="px-[16px] py-[6px] text-[#644d81] font-medium text-[14px] bg-[#ECF0F7] transition-all ease-in-out rounded cursor-pointer hover:bg-[#e4e8ef]"
                        onClick={() => setIsShow(false)}>
                        {t("Cancel")}
                    </button>
                    <button type="submit"
                        className="min-w-[76px] text-center px-[16px] py-[6px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary">
                        {t("Save")}
                    </button>
                </div>
            </div>
        </form>
    );
}

export default AddReplies;
